module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Days.js"));
	}, "Days");
}